import { initializeApp } from 'firebase/app';
import { getRemoteConfig, RemoteConfig } from 'firebase/remote-config';
import type { FeatureFlagValues } from 'common/types/types';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

const firebaseApp = initializeApp(firebaseConfig);

// Firebase Remote Config Flags
enum FEATURE_FLAGS {
  APP_STORE = 'release_scan_app_store',
  CHANGE_PCP = 'release_scan_change_pcp',
  MEDICAL_BENEFIT_DISCLAIMER = 'release_medical_benefit_disclaimer',
}

// In app default values for feature flags - in case of network errors
const REMOTE_CONFIG_DEFAULT_VALUES: Record<FEATURE_FLAGS, FeatureFlagValues> = {
  [FEATURE_FLAGS.APP_STORE]: false,
  [FEATURE_FLAGS.CHANGE_PCP]: false,
  [FEATURE_FLAGS.MEDICAL_BENEFIT_DISCLAIMER]: false,
};

const remoteConfig: RemoteConfig = getRemoteConfig(firebaseApp);

remoteConfig.defaultConfig = REMOTE_CONFIG_DEFAULT_VALUES;

// Override the default 12 hours to 1 hour for production (to align with mobile) and 0 for staging (for easier testing).
// We want to use Remote Config feature flags more like we use BE - immediate result after flipping the flag, which is currently impossible.
// Real-time Remote config not available for web (yet?): https://firebase.google.com/docs/remote-config/real-time
remoteConfig.settings.minimumFetchIntervalMillis =
  import.meta.env.VITE_APP_ENV === 'staging' ? 0 : 3600 * 1000; // 1 hour

export { remoteConfig, REMOTE_CONFIG_DEFAULT_VALUES, FEATURE_FLAGS };
